import type { FetchConfig } from '@nlo/nuxt-common/api/helper-types';
import type { paths } from '~/generated/krasloten-api';

export function createOrdersApi(fetchConfig: FetchConfig) {
	const client = fetchConfig.createClient<paths>();

	return {
		getOrders(query: { page?: number }) {
			return client.GET('/api/my/order/get', { params: { query } });
		},
	};
}
